module.exports = __webpack_public_path__ + "static/media/CACAO_02.9fb684c4.png";